export default "__VITE_ASSET__DdxN4n_I__"